/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NetworkStatusTimespan } from './networkStatusTimespan';
import { Comment } from './comment';
import { DataPlanTimespan } from './dataPlanTimespan';
import { Build } from './build';
import { StringTimespan } from './stringTimespan';
import { LongTimespan } from './longTimespan';
import { ParameterData } from './parameterData';
import { ComProviderTimespan } from './comProviderTimespan';


export interface TrapDto { 
    idDevice?: number;
    id?: number;
    insertTs?: string;
    updateTs?: string;
    deviceTypeId?: string;
    firmwareVersionId?: string;
    bootloaderVersionId?: string;
    parameterDataList?: Array<ParameterData>;
    warranty?: string;
    testDevice?: boolean;
    userSubsystemVisibility?: Array<boolean>;
    batteryTimeline?: Array<StringTimespan>;
    pcbTypeId?: string;
    gpsPlusDevice?: boolean;
    buildInProduction?: Build;
    currentBuild?: Build;
    previousBuilds?: Array<Build>;
    comments?: Array<Comment>;
    replacedById?: number;
    nfcTagUid?: string;
    comType?: TrapDto.ComTypeEnum;
    comIdTimeline?: Array<StringTimespan>;
    comId?: string;
    knownToSendBrokenMessages?: boolean;
    comProviderTimeline?: Array<ComProviderTimespan>;
    dataPlanTimeline?: Array<DataPlanTimespan>;
    networkStatusTimeline?: Array<NetworkStatusTimespan>;
    paymentAccountTimeline?: Array<LongTimespan>;
    airtimeNetworkStatusChangeRequested?: TrapDto.AirtimeNetworkStatusChangeRequestedEnum;
    _class: string;
}
export namespace TrapDto {
    export const ComTypeEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeEnum = typeof ComTypeEnum[keyof typeof ComTypeEnum];
    export const AirtimeNetworkStatusChangeRequestedEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type AirtimeNetworkStatusChangeRequestedEnum = typeof AirtimeNetworkStatusChangeRequestedEnum[keyof typeof AirtimeNetworkStatusChangeRequestedEnum];
}


